import React from 'react';
import { Dialog, IconButton, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import kitchenSyncImage from '../../../utilities/images/KitchenSync/kitchenSync.png';
import ImageCarousel from './ImageCarousel';
import './Projects.css';
import { t } from 'i18next';
import SlideUpTransition from '../SlideUpTransition';
import ProjectActionButtons from './ProjectActionButtons';

interface KitchenSyncDialogProps {
    open: boolean;
    onClose: () => void;
}

const KitchenSyncDialog: React.FC<KitchenSyncDialogProps> = ({ open, onClose }) => {
    const isCompactScreen = useMediaQuery('(max-width: 768px)');

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={isCompactScreen}
            TransitionComponent={SlideUpTransition}
            sx={{
                '& .MuiDialog-paper': {
                    margin: isCompactScreen ? 0 : 2,
                    width: isCompactScreen ? '100vw' : 'auto',
                    maxWidth: isCompactScreen ? '100vw' : 'min(92vw, 960px)',
                    maxHeight: isCompactScreen ? '100dvh' : '95dvh',
                    borderRadius: isCompactScreen ? 0 : 3,
                    overflow: isCompactScreen ? 'auto' : 'hidden',
                },
            }}
        >
            <div className="card">
                <IconButton aria-label="Close dialog" onClick={onClose} className="dialog-close-button" size="small">
                    <CloseIcon fontSize="small" />
                </IconButton>
                
                <div className="title">{t("projectDialogs.kitchenSync.title")}</div>
                
                <div className="card-content">
                    <ImageCarousel images={[kitchenSyncImage]} alt={t("projectDialogs.kitchenSync.title")} />
                    
                    <div className="description">
                        <div className="left-box">
                            {t("projectDialogs.kitchenSync.description")}
                        </div>
                        
                        <div className="right-box">
                            <div>Flutter</div>
                            <div>Dart</div>
                            <div>Material UI</div>
                            <div>Firebase</div>
                            <div>Android</div>
                        </div>
                    </div>
                </div>
                
                <ProjectActionButtons
                    googlePlayUrl="https://play.google.com/store/apps/details?id=com.yourdomain.kitchensync"
                    websiteUrl="https://kitchensync-69c04.web.app"
                />
            </div>
        </Dialog>
    );
};

export default KitchenSyncDialog;